import React, { FC, useEffect, useRef } from 'react'

import Modal from '../Modal'
import { focusTrapCreator } from '../../helper/focusTrapCreator'
import { sendAction } from '../../api/api'
import { actionType } from '../../constants/messageActionType'

import {
  ChangeLanguageButton,
  ChangeLanguageButtonsContainer,
  ChangeLanguageContent,
  ChangeLanguagePaper
} from './ChangeLanguageModal.styles'

interface Props {
  botId: string
  chatId: number
  setIsOpenSwitchLanguageModal: (p: boolean) => void
  switchLanguagePopupText: string
  continueSwitchingLanguageButtonText: string
  cancelSwitchingLanguageButtonText: string
}

const ChangeLanguageModal: FC<Props> = ({
  botId,
  chatId,
  setIsOpenSwitchLanguageModal,
  switchLanguagePopupText,
  continueSwitchingLanguageButtonText,
  cancelSwitchingLanguageButtonText
}) => {
  const changeLanguageModalRef = useRef<HTMLDivElement>(null)

  const handleStayLanguage = () => {
    sendAction(actionType.CONTINUE_LANGUAGE_SWITCHING, botId, chatId)
    setIsOpenSwitchLanguageModal(false)
  }

  const handleCancelSwitch = () => {
    sendAction(actionType.CANCEL_LANGUAGE_SWITCHING, botId, chatId)
    setIsOpenSwitchLanguageModal(false)
  }

  useEffect(() => {
    changeLanguageModalRef.current.focus()
  }, [changeLanguageModalRef.current])

  return (
    <Modal onClose={handleStayLanguage}>
      <ChangeLanguagePaper
        ref={changeLanguageModalRef}
        tabIndex={0}
        role='dialog'
        aria-modal='true'
        aria-labelledby='switch-language-modal-title'
        onKeyDown={(e) => focusTrapCreator(e, changeLanguageModalRef.current, true)}
      >
        <ChangeLanguageContent
          id='switch-language-modal-title'
          dangerouslySetInnerHTML={{
            __html: switchLanguagePopupText
          }}
        />
        <ChangeLanguageButtonsContainer>
          <ChangeLanguageButton
            agreeButton={false}
            onClick={handleCancelSwitch}
          >
            { cancelSwitchingLanguageButtonText }
          </ChangeLanguageButton>
          <ChangeLanguageButton
            agreeButton={true}
            onClick={handleStayLanguage}
          >
            { continueSwitchingLanguageButtonText }
          </ChangeLanguageButton>
        </ChangeLanguageButtonsContainer>
      </ChangeLanguagePaper>
    </Modal>
  )
}

export default ChangeLanguageModal
